@if (digitalCard) {
  <div class="container single-view" id="view-digital-card">
    <div class="row">
      <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
        <div id="pre-header-wr">
          <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/digital-cards"
          class="inline-flex items-center text-base link link-icon left-arrow">{{ 'ITEMS.BTN_BACK_TO_ITEM' | translate }}</a>
        </div>
        <div class="switch-wr"></div>
      </div>
      <div class="col-12">
        <div id="view-header-wr" class="flex flex-wrap items-baseline justify-between gap-4">
          <div class="title-wr">
            <div data-testid="distributionchannel-item">
              <h1 data-testid="section-item" class="section-title mb-3">{{ 'DIGITAL_CARD_SINGLE_VIEW.DIGITAL_CARD_DETAILS' | translate }}
              </h1>
              <div>
                <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                  #{{ digitalCard.id | defaultValue }} @if (digitalCard.productName) {
                  <span data-testid="digitalcard-name"> - {{ digitalCard.productName }}</span>
                }
              </h2>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap justify-between gap-y-4">
          <div id="complementary-details" class="flex flex-wrap">
          </div>
          <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3">
            @if (emailCardIsEnabled && canDisplayDigitalCardPreview) {
              <button data-testid="digital-card-email-btn" class="btn outline-btn" (click)="emailDigitalCard()">
                {{ 'DIGITAL_CARDS.BTN_EMAIL_DIGITAL_CARD' | translate }}
              </button>
            }
            @if (canDisplayDigitalCardPreview) {
              <button data-testid="digital-card-print-btn" class="btn primary-btn" (click)="printDigitalCard()">
                {{ 'DIGITAL_CARDS.BTN_PRINT_DIGITAL_CARD' | translate }}
              </button>
            }
          </div>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <!-- main content -->
        <section class="row mt-4">
          <div class="flex flex-col col-12 col-sm-12 col-md-5 mt-5">
            <!-- digital card -->
            @if (canDisplayDigitalCardPreview) {
              <div #digitalCardPreviewWrapper class="dc-readonly-preview">
                <div class="dc-readonly-stage"
                  [style.width.px]="getReadonlyStageWidth()"
                  [style.height.px]="getReadonlyStageHeight()">
                  <div id="digital-card" class="dc-card dc-readonly-card"
                    [style.width.px]="getReadonlyCardWidth()"
                    [style.height.px]="getReadonlyCardHeight()"
                    [style.transform]="'scale(' + readonlyCardScale + ')'"
                    [style.backgroundColor]="digitalCardConfig.background.color"
                    [style.borderRadius.px]="digitalCardConfig.card.borderRadius">
                    @if (digitalCardConfig.background.type === 'image' && digitalCardConfig.background.imageDataUrl) {
                      <img class="dc-card-bg-image"
                        [src]="digitalCardConfig.background.imageDataUrl" />
                    }
                    @for (key of textElementKeys; track trackByTextElementKey($index, key)) {
                      @if (getTextElement(key); as element) {
                        @if (element.active) {
                          <div class="dc-card-element dc-text-element"
                            [style.left.%]="element.xPercent"
                            [style.top.%]="element.yPercent"
                            [style.color]="getTextElementColor(key)"
                            [style.fontSize.px]="element.fontSize"
                            [style.textAlign]="element.textAlign"
                            [attr.data-testid]="'digital-card-' + key">
                            {{ getTextElementValue(key) | defaultValue }}
                          </div>
                        }
                      }
                    }
                    @if (digitalCardConfig.elements.qrCode?.active && qrData) {
                      <div class="dc-card-element dc-qr-element"
                        [style.left.%]="digitalCardConfig.elements.qrCode?.xPercent"
                        [style.top.%]="digitalCardConfig.elements.qrCode?.yPercent"
                        [style.width.px]="digitalCardConfig.elements.qrCode?.size || 128"
                        [style.height.px]="digitalCardConfig.elements.qrCode?.size || 128"
                        data-testid="digital-card-qr-wrapper">
                        <qrcode
                          data-testid="digital-card-qr"
                          [qrdata]="qrData"
                          [width]="digitalCardConfig.elements.qrCode?.size || 128" [errorCorrectionLevel]="'M'">
                        </qrcode>
                      </div>
                    }
                  </div>
                </div>
              </div>
            } @else {
              <div class="dc-readonly-preview no-card-preview flex min-h-16 flex-col items-center justify-center rounded border p-6 text-center">
                <h4 class="mb-2">{{ 'DIGITAL_CARD_SINGLE_VIEW.PREVIEW_UNAVAILABLE_TITLE' | translate }}</h4>
                @if (digitalCardTemplateIsMissing) {
                  <p class="text-base">{{ 'DIGITAL_CARD_SINGLE_VIEW.NO_TEMPLATE_SETTINGS' | translate }}</p>
                } @else {
                  <p class="text-base">{{ 'DIGITAL_CARD_SINGLE_VIEW.PREVIEW_LOAD_ERROR' | translate }}</p>
                }
              </div>
            }
            <!-- /digital card -->
          </div>
          <div class="col-12 col-sm-12 col-md-7 mt-6">
            <h4 data-testid="digital-card-details">{{ 'DIGITAL_CARD_SINGLE_VIEW.CARD_DETAILS' | translate }}</h4>
            <hr role="presentation" class="w-full mb-2 mt-3 border-t">
            <dl class="details-grid">
              @if (digitalCard.retailerName) {
                <dt data-testid="retailer-name-label" class="label grid-cols-1 pt-3">{{ 'DIGITAL_CARD_SINGLE_VIEW.RETAILER_NAME' | translate }}</dt>
                <dd data-testid="retailer-name" class="value pt-3 pb-3">{{ digitalCard.retailerName | defaultValue }}</dd>
              }
              <dt data-testid="product-label" class="label grid-cols-1 pt-3">{{ 'DIGITAL_CARD_SINGLE_VIEW.PRODUCT_NAME' | translate }}</dt>
              <dd data-testid="product" class="value pt-3 pb-3">
                @if (digitalCard.productId && allowViewProduct) {
                  <a [routerLink]="['/products/', digitalCard.productId]" class="inline-flex items-center link">{{ digitalCard.productName | defaultValue }}</a>
                } @else {
                  {{ digitalCard.productName | defaultValue }}
                }
              </dd>
              @if (digitalCard.serialNumber) {
                <dt data-testid="serialnumber-label" class="label grid-cols-1 pt-3">{{ 'DIGITAL_CARD_SINGLE_VIEW.SERIAL_NUMBER' |
                translate }}</dt>
                <dd data-testid="serialnumber" class="value pt-3 pb-3">{{ digitalCard.serialNumber | defaultValue }}</dd>
              }
              @if (digitalCard.sku) {
                <dt data-testid="sku-label" class="label grid-cols-1 pt-3">{{ 'DIGITAL_CARD_SINGLE_VIEW.SKU' | translate }}</dt>
                <dd data-testid="sku" class="value pt-3 pb-3">{{ digitalCard.sku | defaultValue }}</dd>
              }
              @if (digitalCard.warrantyCode) {
                <dt data-testid="sku-label" class="label grid-cols-1 pt-3">{{ 'DIGITAL_CARD_SINGLE_VIEW.WARRANTY_CODE' | translate }}</dt>
                <dd data-testid="sku" class="value pt-3 pb-3">{{ digitalCard.warrantyCode | defaultValue }}</dd>
              }
              @if (digitalCard.securityPasscode) {
                <dt data-testid="security-passcode-label" class="label grid-cols-1 pt-3">{{ 'DIGITAL_CARD_SINGLE_VIEW.SECURITY_PASSCODE' | translate }}</dt>
                <dd data-testid="security-passcode" class="value pt-3 pb-3 flex items-center gap-2">

                  @if (showSecurityPasscode) {
                    <span>{{ digitalCard.securityPasscode }}</span>
                  } @else {
                    <span class="passcode-mask">**********</span>
                  }

                  <button data-testid="security-passcode-toggle" type="button" class="btn-icon-only btn-icon eye-toggle icon-eye-display" [class.icon-eye-display]="!showSecurityPasscode" [class.icon-eye-hide]="showSecurityPasscode" (click)="toggleSecurityPasscodeVisibility()">
                  </button>
                </dd>
              }
              @if (qrData) {
                <dt data-testid="qr-label" class="label grid-cols-1 pt-3">{{ 'DIGITAL_CARD_SINGLE_VIEW.QR' | translate }}</dt>
                <dd data-testid="qr" class="value pt-3 pb-3 flex gap-2">
                  <button data-testid="copy-qr-btn" type="button" class="inline-flex items-center font-medium link cursor-pointer border-none font-medium" [class.pointer-events-none]="isFetchingQrData || !qrData" (click)="copyToClipboard()">{{ 'DIGITAL_CARD_SINGLE_VIEW.COPY_URL' | translate }}</button>
                  <a id="link-open-url" [href]="qrData" target="_blank" class="inline-flex items-center link font-medium">{{ 'DIGITAL_CARD_SINGLE_VIEW.OPEN_URL' | translate }}</a>
                </dd>
              }
            </dl>
          </div>
        </section>
        <!-- /main content -->
      </div>
    </div>
  </div>
</div>
}

<!-- Modalbox: send digital card via email -->
<p-dialog [header]="'DIGITAL_CARDS.EMAIL_CARD_TITLE' | translate" [(visible)]="displayEmailModalbox" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false" [closable]="true" class="compact-modal">
  <form [formGroup]="emailForm" (ngSubmit)="onSubmitEmailForm()" class="mt-0">
    <div class="field-wr flex flex-col col-12">
      <label data-testid="email-label" class="block text-sm" for="email">{{ 'DIGITAL_CARDS.EMAIL_RECIPIENT' | translate }}
        <i class="icon-required-field"></i>
      </label>
      <input data-testid="email-input" type="text" formControlName="email" autocomplete="off">
      @if (emailForm.get('email')?.invalid && (emailForm.get('email')?.dirty || emailForm.get('email')?.touched)) {
        @if (emailForm.get('email')?.hasError('required')) {
          <small data-testid="email-mandatory" class="p-error">{{ 'DIGITAL_CARDS.EMAIL_REQUIRED' | translate }}</small>
        }
        @if (emailForm.get('email')?.errors?.['invalidEmail']) {
          <small data-testid="email-syntax-error" class="p-error">{{ 'YOUR_ACCOUNT.VALIDATE_EMAIL_SYNTAX' | translate }}</small>
        }
      }
    </div>
  </form>

  <ng-template #footer>
    <button data-testid="cancel-email-btn" type="button" class="btn outline-btn" (click)="onCancelEmailModal()">
      {{ 'MODALBOXES.BTN_CANCEL' | translate }}
    </button>
    <button data-testid="send-email-btn" type="submit" class="btn primary-btn" [disabled]="emailForm.invalid" (click)="onSubmitEmailForm()">
      {{ 'DIGITAL_CARDS.BTN_SEND_EMAIL' | translate }}
    </button>
  </ng-template>
</p-dialog>
